import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-arrow-right",
  "use": "svgIcon-arrow-right-usage",
  "viewBox": "0 0 98 98",
  "content": "<symbol viewBox=\"0 0 98 98\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-arrow-right\"><path d=\"M62.805 13.334l33.894 33.895a2 2 0 010 2.828L62.805 83.953c-.781.78-2.047.78-2.828 0l-9.031-9.028a2.002 2.002 0 010-2.828l14.531-14.536H1.999a2 2 0 01-2-2V41.726a2 2 0 012-2h63.478L50.945 25.193c-.75-.75-.75-2.078 0-2.828l9.031-9.031a2 2 0 012.829 0z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol